import { render, staticRenderFns } from "./PropertyRegistryTab.vue?vue&type=template&id=5787975e&scoped=true&"
import script from "./PropertyRegistryTab.vue?vue&type=script&lang=js&"
export * from "./PropertyRegistryTab.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRegistryTab.vue?vue&type=style&index=0&id=5787975e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787975e",
  null
  
)

export default component.exports